import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class CarrierTypeService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('carrier-type', http, authentication);
  }

  listCarrierTypes() {
    return this.getRequest(`${this.url}/ddl`);
  }

  
}
